window.createTerminal = function (containerId) {
	const fs = {
		home: {
			'info.txt': 'Befindet sich aktuell im Auf- und Umbau. Schaue dich um.',
			'contact.txt': 'mail@bccoding.com',
			docs: {
				'hilfe.txt': 'Befehle: cd, ls, cat, clear, help',
			},
			skills: {
				'developing.txt': 'Web:\nPHP, MySQL, Javascript, ES6, jQuery, REACT, JSON, HTML5/CSS3, Sass, Bash, Git, SVN, Laravel, Docker, Wordpress\n\rMobile App:\nPWA, Flutter, Dart',
				'toolkit.txt': 'ChatGPT, claude.ai by Anthropic, VSCode, PHPStorm, Vim, RegEX',
			},
		},
	};

	let cwd = ['home'];
	let history = [];
	let historyIndex = 0;

	const container = document.getElementById(containerId);
	container.classList.add('terminal');
	container.innerHTML = `<div id="output"></div><div id="input-line"><span class="prompt"></span><input type="text" autofocus></div>`;

	const output = container.querySelector('#output');
	const input = container.querySelector('input');
	const promptEl = container.querySelector('.prompt');

	function getCurrentDir() {
		return cwd.reduce((dir, part) => dir[part], fs);
	}

	function updatePrompt() {
		promptEl.textContent = `/${cwd.join('/')} $ `;
	}

	function print(text = '') {
		output.innerHTML += text + '\n';
		output.scrollTop = output.scrollHeight;
	}

	function clear() {
		output.innerHTML = '';
		print('Du bist im BCCs cli!\nGib `help` ein zum starten.\n\r');
	}

	function listDir() {
		const dir = getCurrentDir();
		return Object.entries(dir).map(([name, value]) => {
			const isDir = typeof value === 'object';
			const cls = isDir ? 'directory' : 'file';
			const icon = isDir ? '📁' : '📄'; // Optional: Icon
			return `<span class="${cls} entry">${icon} ${name}</span>`;
		}).join('');
	}

	function changeDir(dir) {
		if (dir === '..') {
			if (cwd.length > 1) cwd.pop();
		} else if (getCurrentDir()[dir] && typeof getCurrentDir()[dir] === 'object') {
			cwd.push(dir);
		} else {
			return `Verzeichnis nicht gefunden: ${dir}`;
		}
		return '';
	}

	function readFile(file) {
		const dir = getCurrentDir();
		if (dir[file] && typeof dir[file] === 'string') {
			return dir[file];
		}
		return `Datei nicht gefunden: ${file}`;
	}

	function runCommand(inputText) {
		const [cmd, ...args] = inputText.trim().split(/\s+/);
		let result = '';

		switch (cmd) {
			case 'ls':
				result = listDir() + '\n\r';
				break;
			case 'cd':
				result = changeDir(args[0]);
				updatePrompt();
				break;
			case 'cat':
				result = readFile(args[0]) + '\n\r';
				break;
			case 'clear':
				clear();
				return;
			case 'help':
				result = 'Verfügbare Befehle: ls, cd, cat, clear, touch, mkdir, help\n\r';
				break;
			case 'pwd':
				result = `/${cwd.join('/')}\n\r`;
				break;
			case 'whoami':
				result = 'Visitor\n\r';
				break;
			case 'touch':
				const name = args[0];
				if (name) {
					const dir = getCurrentDir();
					if (!dir[name]) {
						dir[name] = '';
						result = `Datei ${name} erstellt\n\r`;
					} else {
						result = `Datei existiert bereits: ${name}\n\r`;
					}
				} else {
					result = 'Dateiname fehlt\n\r';
				}
				break;
			case 'mkdir':
				const dirName = args[0];
				if (dirName) {
					const dir = getCurrentDir();
					if (!dir[dirName]) {
						dir[dirName] = {};
						result = `Verzeichnis ${dirName} erstellt\n\r`;
					} else {
						result = `Eintrag existiert bereits: ${dirName}\n\r`;
					}
				} else {
					result = 'Verzeichnisname fehlt';
				}
				break;
			case 'echo':
				result = args.join(' ');
				break;
			case 'sudo':
				result = 'Du hast keine Macht hier.\n\r';
				break;
			case '':
				return;
			default:
				result = `Unbekannter Befehl: ${cmd}\n\r`;
		}

		print(result);
	}

	input.addEventListener('keydown', (e) => {
		if (e.key === 'Enter') {
			const text = input.value;
			print(`${promptEl.textContent}${text}`);
			history.push(text);
			historyIndex = history.length;
			runCommand(text);
			input.value = '';
		}

		if (e.key === 'ArrowUp') {
			historyIndex = Math.max(0, historyIndex - 1);
			input.value = history[historyIndex] || '';
		}

		if (e.key === 'ArrowDown') {
			historyIndex = Math.min(history.length, historyIndex + 1);
			input.value = history[historyIndex] || '';
		}

		if (e.key === 'Tab') {
			e.preventDefault();
			const text = input.value.trim();
			const [cmd, ...args] = text.split(/\s+/);
			const partial = args[0] || '';
			const currentDir = getCurrentDir();

			if (cmd === 'cd' || cmd === 'cat') {
				const entries = Object.keys(currentDir);
				const isDirOnly = cmd === 'cd';

				const matches = entries.filter(name => {
					const isMatch = name.startsWith(partial);
					if (isDirOnly) return isMatch && typeof currentDir[name] === 'object';
					else return isMatch && typeof currentDir[name] === 'string';
				});

				if (matches.length === 1) {
					input.value = `${cmd} ${matches[0]}`;
				} else if (matches.length > 1) {
					print(matches.join('    '));
				}
			}
		}
	});

	updatePrompt();
	print('Du bist im BCCs cli!\nGib `help` ein zum starten.\n\r');

	const win = document.getElementById('terminal-window');
	const btnMin = win.querySelector('.btn-min');
	const btnMax = win.querySelector('.btn-max');
	const btnClose = win.querySelector('.btn-closing');

	btnMin.addEventListener('click', () => {
		win.classList.toggle('minimized');
	});

	btnMax.addEventListener('click', () => {
		win.classList.toggle('fullscreen');
	});

	btnClose.addEventListener('click', () => {
		win.style.display = 'none';
	});

}